import { Text } from "@otrium/atoms";
import { Box } from "@otrium/core";

const SeperatorMessage = ({
  children,
  ...rest
}: {
  children: any;
}): JSX.Element => {
  return (
    <Box sx={{ borderTop: "1px solid #dddddd", width: "100%" }} {...rest}>
      <Text
        color={"tone.anthraciteLight"}
        fontSize={0}
        px={3}
        sx={{
          position: "relative",
          top: "-12px",
          background: "White",
          left: "50%",
          transform: "translateX(-50%)",
          display: "inline-block",
        }}
        as="span"
      >
        {children}
      </Text>
    </Box>
  );
};

export default SeperatorMessage;
